import type { ReactNode } from "react";
import { Link } from "react-router";
import { useTranslate } from "ra-core";
import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";

export const DashboardWidget = ({
  icon,
  title,
  seeAllTo,
  action,
  children,
}: {
  icon: ReactNode;
  title: string;
  seeAllTo?: string;
  action?: ReactNode;
  children: ReactNode;
}) => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-2 h-full min-h-0">
      <div className="flex items-center shrink-0">
        <div className="mr-3 flex">{icon}</div>
        <h2 className="text-xl font-semibold text-muted-foreground flex-1">
          {title}
        </h2>
        {action}
        {seeAllTo && (
          <Link
            to={seeAllTo}
            className="text-sm text-muted-foreground hover:text-foreground"
          >
            {translate("crm.dashboard.see_all", { _: "See all" })}
          </Link>
        )}
      </div>
      <Card className="flex-1 min-h-0 overflow-hidden p-0">
        <ScrollArea className="h-full">
          <div className="p-4">{children}</div>
        </ScrollArea>
      </Card>
    </div>
  );
};
